import React, { createContext, useContext, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { isBrowser, isMobile } from 'react-device-detect';
import classNames from 'classnames';
import { useWindowListener } from '../reactHooks.js';
import './appLayout.scss';
export function getLayoutSize() {
  if (window.innerWidth < 500) {
    return 'XS';
  } else if (window.innerWidth < 900) {
    return 'S';
  } else if (window.innerWidth < 1300) {
    return 'M';
  } else if (window.innerWidth < 1600) {
    return 'L';
  } else {
    return 'XL';
  }
}
;
export function getLayoutAspectDirection() {
  if (window.innerWidth / window.innerHeight >= 1) {
    return 'layoutHor';
  } else {
    return 'layoutVer';
  }
}
var initialLayoutSize = getLayoutSize();
var initialAppLayout = {
  colorMode: 'lightMode',
  layoutDir: getLayoutAspectDirection(),
  layoutSize: initialLayoutSize,
  isBrowser,
  isMobile,
  menuOverlay: isMobile || ['XS', 'S'].includes(initialLayoutSize)
};
export var AppLayoutContext = /*#__PURE__*/createContext(initialAppLayout);

function AppLayout(props) {
  var {
    className,
    children
  } = props;
  var [colorMode] = useState(props.colorMode || initialAppLayout.colorMode);
  var [layoutSize, setLayoutSize] = useState(initialAppLayout.layoutSize);
  var [menuOverlay] = useState(initialAppLayout.menuOverlay);
  var [layoutDir, setLayoutDir] = useState(initialAppLayout.layoutDir);

  var handleWindowResize = () => {
    var newLayoutSize = getLayoutSize();

    if (newLayoutSize !== layoutSize) {
      setLayoutSize(newLayoutSize);
    }

    var newLayoutDir = getLayoutAspectDirection();

    if (newLayoutDir !== layoutDir) {
      setLayoutDir(newLayoutDir);
    }
  };

  useWindowListener('resize', handleWindowResize);
  return /*#__PURE__*/React.createElement(AppLayoutContext.Provider, {
    value: {
      colorMode,
      layoutDir,
      layoutSize,
      isBrowser,
      isMobile,
      menuOverlay
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(`appLayout ${colorMode} layout${layoutSize} ${layoutDir}`, {
      isMobile
    }, className)
  }, children, /*#__PURE__*/React.createElement(Outlet, null)));
}

export default AppLayout;